<template>
    <div v-if="filter?.availableOperators">
      <!-- WE CANT align="center" BECAUSE FILTERS DOES NOT HAVE hide-details  -->
      <v-row> 
        <!-- OPERATOR -->
        <v-col :cols="filter.availableOperators ? 3 : 0"  class="pr-0">
          <v-select
            :value="$translate(`operators.${filter.operator}`)"
            :items="filter.availableOperators"
            variant="solo"
            hide-details="true"
            no-data-text="Aucun choix disponible"
            @update:model-value="$emit('updateOperator', $event)"
          >
            <!-- TEMPLATE IN DROPDOWN -->
            <template #item="{ props, item }">
              <v-list-item v-bind="props">
                <v-list-item-title class="select-options">
                  {{ $translate(`operators.${item.value}`) }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <!-- TEMPLATE IN SELECT INPUT -->
            <template #selection="{ item }">
              {{ $translate(`operators.${item.value}`) }}
            </template>
          </v-select>
        </v-col>

        <!--  FILTER -->
        <v-col 
          :cols="filter.availableOperators ? 7 : 12"
        >
          <slot
            name="input"
          />
        </v-col>

        <!-- + OR TRASH BTN -->
        <v-col
            :cols="filter.availableOperators ? 1 : 0"
            class="pl-0 text-center"
          >
            <v-tooltip
              v-if="addEnabled"
              :text="`Ajouter un nouveau filtre ${$translate(`${translationName}.${filter.name}`)} pour rechercher avec un second opérateur`"
            >
              <template #activator="{ props }">
                <v-btn
                  class="mt-3"
                  color="secondary"
                  v-bind="props"
                  variant="tonal"
                  size="small"
                  @click="$emit('addFilter', {...filter, value : null, operator : 'eq'})"
                >
                  <v-icon
                    icon="mdi-plus"
                    size="small"
                  />
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip
              v-if="!addEnabled"
              :text="`Supprimer ce filtre ${$translate(`${translationName}.${filter.name}`)}`"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  class="mt-3"
                  variant="tonal"
                  color="danger"
                  size="small"
                  @click="$emit('deleteFilter', filter)"
                >
                  <v-icon
                    icon="mdi-delete"
                    size="small"
                  />
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>

      </v-row>
    </div>
    <template v-else>
      <slot
        name="input"
      />
    </template>
</template>
<script lang="ts">
export default {
    name : "OperatorGroup",
    props: {
        translationName: { type: String, required: true },
        filter: { type: Object, required: true },
        filters: { type: Array, required: true },
    },
    emits: ['deleteFilter', 'addFilter', 'updateOperator'],
    data () {
        return {
        }
    },
    computed : {
      addEnabled () {
        const sameFilters = this.filters.filter( f => f.name === this.filter.name)
        return sameFilters.length <= 1
      },
    },
}
</script>
